<template>

    
      <v-col>
          <v-card flat>
         <v-data-table
            :key="componentKey"
            :headers="computedHeaders"
            :items="tableItems"
            class="elevation-1"
            :loading="yearsLoadStatus===1"
            :options.sync="tableOptions"
            :server-items-length="options.lineCount"
            hide-default-footer
            must-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Lata szkolne</v-toolbar-title>
                
                <!-- <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                

                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Wyszukaj"
                      single-line
                      hide-details
                      class="search"
                      @keydown.enter="searchYears"
                  ></v-text-field>
                  </template>
                    <span>Wpisz min 3 znaki i naciśnij Enter</span>
                </v-tooltip> -->
                 

                <v-spacer></v-spacer>

                <v-checkbox v-model="showDeleted" class="mt-4" label="Pokaż wyłączone"></v-checkbox>

                <v-divider
                  v-if="user.permissions['dictionary'] >= 10"
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                <v-dialog v-if="user.permissions['dictionary'] >= 10" v-model="dialog" max-width="700px">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small class="mb-2 mt-2" fab dark color="primary">
                      <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <v-card  :loading="yearAddStatus===1 || yearEditLoadStatus===1 || yearEditStatus===1">
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                      <v-spacer></v-spacer>
                      <v-checkbox
                                :disabled="itemEditing && itemWasDefault"
                                v-model="editedItem.default"
                                label="Domyślny"
                              ></v-checkbox>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        
                          <v-row>                   
                            <v-col cols="12" sm="4" md="4">
                              <v-text-field v-model="editedItem.name" :error-messages="nameErrors" required @input="$v.editedItem.name.$touch()"  @blur="$v.editedItem.name.$touch()"  label="Nazwa"></v-text-field>                            
                            </v-col>
                            

                            <v-col cols="12" sm="4" md="4">
                              <v-menu
                                v-model="dateFromMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="150px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-model="editedItem.from"
                                    :error-messages="fromErrors"
                                    required
                                    @input="$v.editedItem.from.$touch()"
                                    @blur="$v.editedItem.from.$touch()"
                                    label="Od"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                    class="choose_date"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                 first-day-of-week="1"
                                  no-title
                                  v-model="editedItem.from"
                                  @input="dateFromMenu = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                              <v-menu
                                v-model="dateToMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="150px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                  :error-messages="toErrors"
                                    required
                                    @input="$v.editedItem.to.$touch()"
                                    @blur="$v.editedItem.to.$touch()"
                                    v-model="editedItem.to"
                                    label="Do"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                    class="choose_date"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  first-day-of-week="1"
                                  no-title
                                  v-model="editedItem.to"
                                  @input="dateToMenu = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                               <h3 class="mb-3">Dni wolne <v-chip class="ma-2" color="primary" small><strong>{{editedItem.holidays.length}}</strong></v-chip></h3>
                               <v-date-picker
                                  :disabled="!editedItem.from || !editedItem.to"
                                  first-day-of-week="1"
                                  no-title
                                  :show-current="false"
                                  multiple
                                  :min="editedItem.from"
                                  :max="editedItem.to"
                                  v-model="editedItem.holidays"
                                  
                                ></v-date-picker>
                            </v-col>
                           <v-col cols="12" sm="6" md="6">
                             <p :disabled="!editedItem.from || !editedItem.to" class="mt-12">Zaznacz dni wolne lub skorzystaj z opcji poniżej:</p>
                             <v-btn :disabled="!editedItem.from || !editedItem.to" @click="addWeekend(editedItem.from,editedItem.to)" class="mb-3 mr-10" outlined small color="primary">Dodaj weekendy</v-btn>
                             <v-btn :disabled="!editedItem.from || !editedItem.to" @click="addHoliday(editedItem.from,editedItem.to)" class="mb-3 mr-10" outlined small color="primary">Dodaj święta</v-btn>
                             <v-btn :disabled="!editedItem.from || !editedItem.to" @click="editedItem.holidays = []" class="mb-3 mr-10" outlined small color="primary">Wyczyść zaznaczenie</v-btn>
                           </v-col>
                           
                          </v-row>
                        
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray" text @click="close">Anuluj</v-btn>
                      <v-btn color="primary darken-1" text @click="handleSubmit" >Zapisz</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-tooltip v-if="item.status && user.permissions['dictionary'] >= 10" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    @click="editItem(item)"
                  >
                    mdi-pencil
                  </v-icon>
                  </template>
                    <span>Edytuj</span>
                </v-tooltip>

                <v-tooltip v-if="item.status && item.can_delete && user.permissions['dictionary'] >= 10" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class=""
                    @click="deleteItem(item)"
                  >
                    mdi-delete
                  </v-icon>
                  </template>
                  <span>Usuń</span>
                </v-tooltip>

                <v-tooltip v-if="!item.status  && user.permissions['dictionary'] >= 20" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    @click="reactivateItem(item)"
                  >
                    mdi-delete-restore
                  </v-icon>
                  </template>
                  <span>Przywróć</span>
                </v-tooltip>

                <v-tooltip v-if="!item.status && item.can_delete  && user.permissions['dictionary'] >= 20" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class=""
                    color="error"
                    @click="forceDeleteItem(item)"
                  >
                    mdi-delete-forever
                  </v-icon>
                  </template>
                  <span>Usuń na stałe</span>
                </v-tooltip>

                
            </template>

            <template v-slot:item.default="{ item }">
              <v-simple-checkbox v-model="item.default" disabled></v-simple-checkbox>
            </template> 

            <template v-slot:item.from="{ item }">
              {{item.from}} - {{item.to}}
            </template>       

            <template v-slot:item.status="{ item }">
              <v-simple-checkbox v-model="item.status" disabled></v-simple-checkbox>
            </template>

          </v-data-table> 
          <div class="text-center pt-2">
            <v-btn @click="loadMore" v-if="!options.itemAdded && options.lineCount-tableItems.length>0 && yearsLoadStatus===2" small color="primary"><v-icon left>mdi-download</v-icon>Załaduj więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadYears" v-else-if="options.itemAdded && options.lineCount-tableItems.length>0" small color="primary"><v-icon left>mdi-reload</v-icon>Odśwież tabele aby móc załadować więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadYears" v-else-if="options.itemSearched" small color="primary"><v-icon left>mdi-reload</v-icon>Anuluj wyszukiwanie</v-btn>
          
          </div>

          </v-card>
      
      <confirm ref="confirm"></confirm>
      </v-col>
      

</template>

<script>
  import confirm from '../components/Confirm'
  import Vue from 'vue'
  import required from 'vuelidate/lib/validators/required'
  import minValue from 'vuelidate/lib/validators/minValue'

  export default {
    components:{
      confirm
    },
    data: () => ({
      componentKey:0,
      tableOptions: {},
      dialog: false,
      itemEditing:false,
      search:'',
      itemWasDefault:false,
      dateFromMenu: false,
      dateToMenu: false,
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp',filterable:false},
        { text: 'Nazwa', value: 'name',filterable:true },
        { text: 'Daty', value: 'from',filterable:false },
        { text: 'Domyślny', value: 'default',filterable:false },
        { text: 'Cenniki', value: 'rates_count',filterable:false },
        { text: 'Grupy', value: 'courses_count',filterable:false },
        { text: 'Status', value: 'status',filterable:false },
        { text: 'Akcje', value: 'actions', sortable: false,filterable:false },
      ],
    }),
    validations: {
      editedItem:{
        name: {
          required,
        },
        from: {
          required,
        },
        to: {
          required,
          
        },
      }
    },
    watch: {
      tableOptions: {
        handler () {
          var currentOptions = {...this.options};
          const { sortBy, sortDesc } = this.tableOptions
        
          //zmiana sortowania
          if (sortBy.length === 1 && sortDesc.length === 1) {
            currentOptions.orderBy = sortBy[0];
            currentOptions.orderDirection = sortDesc[0]?'desc':'asc';
            this.options = currentOptions;
          } 
        },
        deep: true,
      },
    
      dialog (val) {
        this.$v.$reset()
        val || this.close()
      },
      yearEditStatus(val){
        if(val===2){
          this.close();
          this.componentKey += 1;
        }
      },
      yearAddStatus(val){
        if(val===2){
          this.close();
          this.componentKey += 1;
        }
      },
      yearDeleteStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      }
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      options:{
        get () {  
          return this.$store.getters.getYearOptions;
        },
        set (value) {
          this.search='';
          this.$store.dispatch( 'setYearOptions', {options:value} )
        }
      },
      showDeleted: {
        get () {
          return this.$store.getters.getYearOptions.showDeleted;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.showDeleted = value;
          this.options = currentOptions;
        }
      },
      editedItem(){
        return this.$store.getters.getYearEdit;
      },
      tableItems(){
        return this.$store.getters.getYears;
      },
      yearsLoadStatus(){
        return this.$store.getters.getYearsLoadStatus;
      },
      yearEditLoadStatus(){
        return this.$store.getters.getYearEditLoadStatus
      },
      yearEditStatus(){
        return this.$store.getters.getYearEditStatus();
      },
      yearEditText(){
        return this.$store.getters.getYearEditText
      },
      yearAddStatus(){
        return this.$store.getters.getYearAddStatus();
      },
      yearAddText(){
        return this.$store.getters.getYearAddText;
      },
      yearDeleteStatus(){
        return this.$store.getters.getYearDeleteStatus();
      },
      computedHeaders () {
        if(!this.showDeleted && this.user.permissions['dictionary'] <= 5) return this.headers.filter(h => h.value!=='status' && h.value!=='actions')
        else if(this.showDeleted && this.user.permissions['dictionary'] <= 5) return this.headers.filter(h => h.value!=='actions')
        else if(!this.showDeleted) return this.headers.filter(h => h.value!=='status')
        else return this.headers
      },
      formTitle () {
        return !this.itemEditing ? 'Nowy rok szkolny' : 'Edycja roku szkolnego'
      },
      nameErrors () {
        const errors = []
        if (!this.$v.editedItem.name.$dirty) return errors
        !this.$v.editedItem.name.required && errors.push('Nazwa jest wymagana')
        return errors
      },
      fromErrors() {
        const errors = [];
        if (!this.$v.editedItem.from.$dirty) return errors;
        !this.$v.editedItem.from.required && errors.push("Data jest wymagana");
        return errors;
      },
      toErrors() {
        const errors = [];
        if (!this.$v.editedItem.to.$dirty) return errors;
        !this.$v.editedItem.to.required && errors.push("Data jest wymagana");
        return errors;
      },
    },
    mounted(){
      this.loadYears();
    },
    methods: {
      easter_date(Y) {
        var C = Math.floor(Y/100);
        var N = Y - 19*Math.floor(Y/19);
        var K = Math.floor((C - 17)/25);
        var I = C - Math.floor(C/4) - Math.floor((C - K)/3) + 19*N + 15;
        I = I - 30*Math.floor((I/30));
        I = I - Math.floor(I/28)*(1 - Math.floor(I/28)*Math.floor(29/(I + 1))*Math.floor((21 - N)/11));
        var J = Y + Math.floor(Y/4) + I + 2 - C + Math.floor(C/4);
        J = J - 7*Math.floor(J/7);
        var L = I - J;
        var M = 3 + Math.floor((L + 40)/44);
        var D = L + 28 - 31*Math.floor(M/4);

        return new Date(Y, M-1, D,12,0,0);
      },
      addWeekend(from,to){
        var start = new Date(from);
        var end = new Date(to);
        for (var d = start; d <= end; d.setUTCDate(d.getUTCDate() + 1)) {
            if ((d.getDay() == 0) || (d.getDay() == 6)) {
              var str = d.toISOString().substr(0,10);
              if(Vue._.indexOf(this.editedItem.holidays,str)<0)this.editedItem.holidays.push(str);
            }
        }
      },
      addHoliday(from,to){
        var year_from = (new Date(from)).getFullYear();
        var year_to = (new Date(to)).getFullYear();
        //tabela świat, dla obydwu lat
        var swieta = [new Date(year_from+"-01-01").toISOString().substr(0,10),new Date(year_from+"-01-06").toISOString().substr(0,10),new Date(year_from+"-05-01").toISOString().substr(0,10),new Date(year_from+"-05-03").toISOString().substr(0,10),new Date(year_from+"-08-15").toISOString().substr(0,10),new Date(year_from+"-11-01").toISOString().substr(0,10),new Date(year_from+"-11-11").toISOString().substr(0,10),new Date(year_from+"-12-25").toISOString().substr(0,10),new Date(year_from+"-12-26").toISOString().substr(0,10)
                     ,new Date(year_to+"-01-01").toISOString().substr(0,10),new Date(year_to+"-01-06").toISOString().substr(0,10),new Date(year_to+"-05-01").toISOString().substr(0,10),new Date(year_to+"-05-03").toISOString().substr(0,10),new Date(year_to+"-08-15").toISOString().substr(0,10),new Date(year_to+"-11-01").toISOString().substr(0,10),new Date(year_to+"-11-11").toISOString().substr(0,10),new Date(year_to+"-12-25").toISOString().substr(0,10),new Date(year_to+"-12-26").toISOString().substr(0,10)];
        var wielkanoc = this.easter_date(year_from);
        swieta.push(wielkanoc.toISOString().substr(0,10));
        wielkanoc.setUTCDate(wielkanoc.getUTCDate() + 1);swieta.push(wielkanoc.toISOString().substr(0,10));
        wielkanoc.setUTCDate(wielkanoc.getUTCDate() + 48);swieta.push(wielkanoc.toISOString().substr(0,10));
        wielkanoc.setUTCDate(wielkanoc.getUTCDate() + 11);swieta.push(wielkanoc.toISOString().substr(0,10));
        wielkanoc = this.easter_date(year_to);
        swieta.push(wielkanoc.toISOString().substr(0,10));
        wielkanoc.setUTCDate(wielkanoc.getUTCDate() + 1);swieta.push(wielkanoc.toISOString().substr(0,10));
        wielkanoc.setUTCDate(wielkanoc.getUTCDate() + 48);swieta.push(wielkanoc.toISOString().substr(0,10));
        wielkanoc.setUTCDate(wielkanoc.getUTCDate() + 11);swieta.push(wielkanoc.toISOString().substr(0,10));
        
        var start = new Date(from);
        var end = new Date(to);
        for (var d = start; d <= end; d.setUTCDate(d.getUTCDate() + 1)) {
            if (swieta.indexOf(d.toISOString().substr(0,10))>0) {
              var str = d.toISOString().substr(0,10);
              if(Vue._.indexOf(this.editedItem.holidays,str)<0)this.editedItem.holidays.push(str);
            }
        }
      },
      loadYears(){
        this.search='';
        this.$store.dispatch( 'loadYears' );
      },
      loadMore(){
        this.$store.dispatch( 'loadMoreYears' );
      },
      reactivateItem(item){
        this.$store.dispatch( 'editYearReactivate',{slug:item.id});
      },
      editItem (item) {
        this.itemWasMain = item.main;
        this.itemEditing = true
        this.$store.dispatch( 'loadYearEdit', {slug:  item.id});  
        this.dialog = true
      },
      deleteItem (item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz wyłączyć rok szkolny?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'deleteYear', {slug:  item.id});
            }
        })
      },
      forceDeleteItem (item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz usunać rok szkolny na stałe?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'forceDeleteYear', {slug:  item.id});
            }
        })
      },
      searchYears(){
        if(this.search.length>2){
          const filterableHeaders = _.join(_.map(_.filter(this.headers,{'filterable':true}),'value'),';');
          this.$store.dispatch( 'searchYears',{filterableHeaders:filterableHeaders,q:this.search});
        }
      },
      close () {
        this.dialog = false
        this.$v.$reset()
        setTimeout(() => {
          this.$store.dispatch( 'loadYearEditDefault'); 
          this.$store.dispatch( 'loadYearAddDefault');
          this.itemEditing = false
        }, 300)
      },
      handleSubmit () {
        this.$v.$touch()
        if (this.$v.$invalid) {

        } else {
         
            if (this.itemEditing) {
              //edycja
              this.$store.dispatch( 'editYear', {
                slug: this.editedItem.id,
                name:  this.editedItem.name,
                from:  this.editedItem.from,
                to:  this.editedItem.to,
                holidays: this.editedItem.holidays,
                _default:  this.editedItem.default, 
              });
            } else {//new item
              this.$store.dispatch( 'addYear', {
                  name:  this.editedItem.name,
                  from:  this.editedItem.from,
                  to:  this.editedItem.to,
                  holidays: this.editedItem.holidays,
                  _default:  this.editedItem.default,
              });

            }
        }
      },
    },
  }
</script>


<style scoped>
.search{
      max-width: 250px;
}
</style>